+function($) {
	'use strict';
	
	var CheckoutSteps = function(element, options) {
		this.options = options;
		this.$element = $(element);
		this.$form = $(this.options.formSelector);

		this.$btnOrder = this.$form.find(this.options.btnOrderSelector).find('input[type="submit"]');
		this.$btnNext = $(this.options.BtnNextSelector);
		this.$btnBack = $(this.options.BtnBackSelector);
		this.$stepBoxes = $(this.options.stepBoxSelector);
		this.$btnGetRate = $(this.options.btnGetRateSelector);
		this.$upsResults = $(this.options.shippingUpsResults);
		this.step = 1;
		this.maxStep = 3;
		
		this.useShippingForBilling = false;
		
		this.initialize();
	};
	
	CheckoutSteps.DEFAULTS = {
		BtnNextSelector: '.btn-steps .btn-next',
		BtnBackSelector: '.btn-steps .btn-back',
		stepBoxSelector: '.step-boxes',
		copyShippingSelect: '.copy-shipping',
		btnOrderSelector: '.btn-order',
		billingAddressSelector: 'tr.billing_address_field',
		formSelector: '#checkout-form',
		validateField: 'input[data-validate]',
		btnGetRateSelector: '#shipping-ups-options .shipping-rate .btn',
		shippingUpsResults: '#shipping-ups-results',
		cityFieldSelecotr: '#checkout-form .city',
		messageEnterRequired: 'Error: please enter the required fields.',
		messageGetUPSRate: 'Error: Please get shipping rate before checkout.',
		messagePopGetRate: 'Please click following button to calculate the shipping rate',
		messageEmptyShippingModule: 'Error: Please choose correct address or shipping method before checkout.',
		messageCalculatingShipping: 'Error: Please wait while the shipping cost is calculated.',
		currentPaymentMethod: null,
		durationDestroyPop: 3500,
		durationHideError: 5000
	};
	
	CheckoutSteps.prototype.initialize = function() {
		this.initPaymentMethods(this.options.currentPaymentMethod);
		
		//check validation after clicking place order button
		this.finalCheckout();
		
		//click next button
		this.observeNext();
		
		//click prev button
		this.observeBack();
		
		//payment methonds
		this.observePaymentMethods();
		
		//click copy shipping button
		this.observeCopyShipping();
		
		this.subscribers();
	};
	
	CheckoutSteps.prototype.subscribers = function() {
		var scope = this;
		
		//show error as getting shipping rate unsuccessfully
		$.subscribe('sn.checkout.getshippingfailed.sn', function(event) {
			var alertMessage = '<p class="alert alert-error">Failed to get shipping rate, please ensture address, city, zipcode and state is valid.</p>';
			
			scope.showPopover(alertMessage, scope.$btnGetRate);
		});
		
		//zipcode updated
		$.subscribe('sn.checkout.zipcodeupdated', function(event) {
			$(scope.options.cityFieldSelecotr).removeClass('invalid');
			$(scope.options.cityFieldSelecotr).nextAll('p.error-help').hide();
		});
	};
	
	CheckoutSteps.prototype.observeCopyShipping = function() {
		var scope = this;
		
		this.$form.on('click', this.options.copyShippingSelect, function() {
			var checkbox = $(this), 
				billingFields = checkbox.parents('table').find(scope.options.billingAddressSelector),
				inputFields = billingFields.find('input'),
				selectFields = billingFields.find('select');
			
			//toggle field disable state
			if (this.checked) {
				billingFields.addClass("hide");
				
				inputFields.attr('disabled', 'disabled');
				selectFields.attr('disabled', 'disabled');
				
				scope.useShippingForBilling = true;
			}else {
				billingFields.removeClass("hide");
				inputFields.removeAttr('disabled');
				selectFields.removeAttr('disabled');
				
				scope.useShippingForBilling = false;
			}
		});
	};
	
	CheckoutSteps.prototype.observeNext = function() {
		var scope = this,
			hammerNext = new Hammer(this.$btnNext[0]);
		
		hammerNext.on('tap', function() {
			if (scope.step == scope.maxStep) {
				return false;
			}
			
			//validate fields in current step form
			if ( ! scope.validate()) {
				
				//scroll up to the error fields automatically
				scope.scrollUp();
				
				return false;
			}
			
			//check shipping module only at the first step
			if (scope.step == 1) {
				if ( ! scope.checkShippingModule()) {
					
					//scroll up to the error fields automatically
					scope.scrollUp(scope.$stepBoxes);
					
					return false;
				}
			}
			
			scope.step++;
			
			scope.forward();
			
			if (scope.step == scope.maxStep) {
				$(this).addClass('disabled');
			}
			
			return false;
		});
	};
	
	CheckoutSteps.prototype.observeBack = function() {
		var scope = this,
			hammerBack = new Hammer(this.$btnBack[0]);
		
		hammerBack.on('tap', function() {
			if ($(this).hasClass('disabled')) {
				return false;
			}
			
			if (scope.step == 1) {
				return false;
			}
			
			scope.step--;
			
			scope.back();
			
			if (scope.step == 1) {
				scope.disableBack();
			}
			
			return false;
		});
	};
	
	CheckoutSteps.prototype.validate = function() {
		var currentStepContainer = this.$stepBoxes.find('.step-' + this.step),
			frmFields = currentStepContainer.find(this.options.validateField);
		
		if (frmFields.length > 0) {
			//delegate to form validator
			if ( ! this.$form.data('sn.formvalidator').checkFields(frmFields)) {
				return false;
			}
		}
		
		return true;
	};
	
	CheckoutSteps.prototype.observePaymentMethods = function() {
		var scope = this;
		
		this.$form.on('change', '.payment-option input', function() {
			var paymentCode = $(this).val();
			
			scope.initPaymentMethods(paymentCode);
			
			return false;
		})
	};
	
	CheckoutSteps.prototype.initPaymentMethods = function(module) {
		var activedModule = $('#pmt-' + module),
			currentOptions,
			nextOptions,
			scope = this;
		
		if (activedModule.length == 0) {
			return;
		}
		
		currentOptions = activedModule.parents('.payment-info ').find('.options');
		nextOptions = activedModule.next('.options');
		
		currentOptions.hide();
		currentOptions.find('input').attr('disabled', true);
		currentOptions.find('select').attr('disabled', true);
		
		nextOptions.show();
		
		
		nextOptions.find('input').removeAttr('disabled');
		nextOptions.find('select').removeAttr('disabled');
		
		//diable fields if use shipping address for billing address
		if (scope.useShippingForBilling) {
			nextOptions.find('.billing_address_field.hide input').attr('disabled', 'disabled');
			nextOptions.find('.billing_address_field.hide select').attr('disabled', 'disabled');
		}
		
	}
	
	CheckoutSteps.prototype.finalCheckout = function() {
		var scope = this;
		
		this.$form.on('submit', function (e) {
			var error = false;
			
			//check form validator
			if ( ! scope.$form.data('sn.formvalidator').isValid()) {
				scope.showError(scope.options.messageEnterRequired);
				
				error = true;
			}
			
			//check quoting
			if (error === false) {
				if (window.quoting) {
					this.showError(scope.options.messageCalculatingShipping);
					
					error = true;
				}
			}
			
			//check shipping module
			if (error === false) {
				if ( ! scope.checkShippingModule()) {
					error = true;
				}
			}
			
			//cancel the submit
			if (error == true) {
				return false;
			}

			scope.showCheckoutingLoader();
		});
	};

	CheckoutSteps.prototype.showCheckoutingLoader = function() {
		this.$btnOrder.addClass('disabled');
		
		$('<div class="ui active small inline loader"></div>').insertBefore(this.$btnOrder);
	};
	
	CheckoutSteps.prototype.checkShippingModule = function() {
		var shippingModule = $('#shipping_module').val();
		
		if ( ! shippingModule) {
			this.showError(this.options.messageEmptyShippingModule);
			
			return false;
		}else if (shippingModule=='ups' && this.$upsResults.find('select').length == 0) {
			this.showPopover(this.options.messagePopGetRate, this.$btnGetRate);
			
			this.showError(this.options.messageGetUPSRate);
			
			return false;
		}
		
		return true;
	};
	
	CheckoutSteps.prototype.showError = function(error) {
		var alert = $(this.options.btnOrderSelector).find('.alert');
		
		alert.html(error).show();
		
		setTimeout(function() {
			alert.hide();
		}, this.options.durationHideError);
	};
	
	CheckoutSteps.prototype.showPopover = function(message, attachedField) {
		var field,
			scope = this;
		
		if (attachedField) {
			field = attachedField;
		}else {
			field = this.$form.find('input[type="submit"]');
		}
		
		field.popover({
			title: '<i class="icon-warning-sign"></i> Warning',
			placement: 'top',
			container: 'body',
			html: true,
			content: '<p class="alert alert-error">' + message + '</p>'
		});
		
		field.popover('show');
		
		setTimeout(function() {
			field.popover('destroy').show();
		}, scope.options.durationDestroyPop);
	};
	
	CheckoutSteps.prototype.forward = function() {
		var scope = this;
		
		//show ajax notification
		$.publish('showajaxnotification.sn');
		
		var prevSelector = 'li:nth-child(' + (this.step - 1) + ')',
			currentSelector = 'li:nth-child(' + this.step + ')',
			prevBoxSelector = '.step-' + (this.step - 1),
			currentBoxSelector = '.step-' + this.step;
		
		this.$element.find(prevSelector).find('span').removeClass('current').addClass('complete');
		
		if (this.step == this.maxStep) {
			this.$element.find(currentSelector).find('span').removeClass('disabled').addClass('complete');
		}else {
			this.$element.find(currentSelector).find('span').removeClass('disabled').addClass('current');
		}
		
		setTimeout(function() {
			scope.$stepBoxes.find(prevBoxSelector).addClass('hidden-xs');
			scope.$stepBoxes.find(currentBoxSelector).removeClass('hidden-xs');
			
			if (scope.step == scope.maxStep) {
				$(scope.options.btnOrderSelector).removeClass('hidden-xs');
			}
			
			$.publish('hideajaxnotification.sn');
		}, 100);
		
		//enable back btn
		this.enableBack();
		
		//scroll up to the error fields automatically
		this.scrollUp();
	};
	
	CheckoutSteps.prototype.back = function() {
		var scope = this;
		
		//show ajax notification
		$.publish('showajaxnotification.sn');
		
		var nextSelector = 'li:nth-child(' + (this.step + 1) + ')',
			currentSelector = 'li:nth-child(' + this.step + ')',
			nextBoxSelector = '.step-' + (this.step + 1),
			currentBoxSelector = '.step-' + this.step;
		
		//add active state for prev step line btn
		this.$element.find(currentSelector).find('span').addClass('current').removeClass('complete');
		
		//remove active state from next step line btn
		if (this.step + 1 == this.maxStep) {
			this.$element.find(nextSelector).find('span').addClass('disabled').removeClass('complete');
		}else {
			this.$element.find(nextSelector).find('span').addClass('disabled').removeClass('current');
		}
		
		setTimeout(function() {
			//show current step box
			scope.$stepBoxes.find(currentBoxSelector).removeClass('hidden-xs');
			
			//hide next step box
			scope.$stepBoxes.find(nextBoxSelector).addClass('hidden-xs');
			
			//hide place order button
			$(scope.options.btnOrderSelector).addClass('hidden-xs');
			
			$.publish('hideajaxnotification.sn');
		}, 100);
		
		//scroll up to the error fields automatically
		this.scrollUp();
		
		//enable next button
		this.enableNext();
	};
	
	CheckoutSteps.prototype.scrollUp = function(element) {
		var offset;
		
		if (element) {
			offset = element.offset();
		}else {
			offset = this.$form.offset();
		}
		
		$.scrollTo(offset.top);
	};
	
	CheckoutSteps.prototype.enableNext = function() {
		this.$btnNext.removeClass('disabled').removeAttr('disabled');
	};
	
	CheckoutSteps.prototype.disableNext = function() {
		this.$btnNext.attr('disabled', 'disabled');
	};
	
	CheckoutSteps.prototype.enableBack = function() {
		this.$btnBack.removeClass('disabled').removeAttr('disabled');
	};
	
	CheckoutSteps.prototype.disableBack = function() {
		this.$btnBack.attr('disabled', 'disabled');
	};
	
	function Plugin(option) {
	    return this.each(function () {
    		var $this   = $(this),
    			data    = $this.data('sn.CheckoutSteps'),
    			options = $.extend({}, CheckoutSteps.DEFAULTS, typeof option == 'object' && option);
	      
	      if ( ! data) {
	    	  $this.data('sn.CheckoutSteps', (data = new CheckoutSteps(this, options)));  
	      } 
	      
	      if (typeof option == 'string') {
	    	  data[option]();  
	      } 
	    });
	}
	
	var old = $.fn.CheckoutSteps;
	
	$.fn.CheckoutSteps = Plugin;
	$.fn.CheckoutSteps.Constructor = CheckoutSteps;
	
	$.fn.CheckoutSteps.noConflict = function () {
	    $.fn.CheckoutSteps = old;
	    return this;
	};
}(jQuery);